import { warenkorbBubbleUpdate } from "../../common/customEvents";
import { getCookieByName, setCookie } from "../../common/cookie";
import { callbackSyncShoppingCart } from "../../common/appCallback";
import { fetchTimeout } from "../../common/fetch-timeout";

class LivebuyWarenkorb extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      this.initLivebuyWarenkorb();
    }, 500);
  }

  initLivebuyWarenkorb() {
    if (this.isLivebuyInDom() && this.isLivebuyCartInitialized() === false) {
      this.setAttribute("data-initialized", "true");
      this.initLivebuyCallbacks();
      this.initMessageListener();
    }
  }
  
  isLivebuyInDom() {
    return (window.livebuy) ? true : false;
  }

  isLivebuyCartInitialized() {
    return document.querySelector("livebuy-warenkorb[data-initialized=true]") ? true : false;
  }

  initLivebuyCallbacks() {
    const livebuyCallback = (data) => {
      this.handleLivebuyEvent(data);
    };
    livebuy.Cart.registerCallback(livebuyCallback);
  }

  handleLivebuyEvent(eventData) {
    const action = eventData.action;
    const wkCookieId = getCookieByName("warenkorb_id");

    if (action === "add_product") {
      const artikelnummer = eventData.item.productNumber;
      const url = `/api/warenkorb/livebuy/${wkCookieId}`;
      const method = "POST";
      const requestBody = {
        "artikelnummer": artikelnummer,
        "menge": 1
      };
      this.performFetch(url, method, requestBody, wkCookieId, action);
    } else if (action === "remove_product") {
      const artikelnummer = eventData.item.productNumber;
      const url = `/api/warenkorb/livebuy/${wkCookieId}/artikelnummer/${artikelnummer}`;
      const method = "DELETE";
      this.performFetch(url, method, "", wkCookieId, action);
    }
  }

  async performFetch(url, method, requestBody, wkCookieId, action) {
    const config = {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };
    
    try {
      const response = await fetchTimeout(url, config);
      if (response.status === 200) {
          const jsonResponse = await response.json();
          const warenkorbId = jsonResponse.warenkorbId;
  
          if ( wkCookieId === "" || wkCookieId != warenkorbId ) {
            setCookie("warenkorb_id", warenkorbId);
          }
          if (this.isApp) {
            callbackSyncShoppingCart(this, warenkorbId);
          } else {
            warenkorbBubbleUpdate(this);
          }

          this.gaTracking(action, jsonResponse);
      }
    } catch (error) {
      console.error("FetchError: " + error);
    }
  }

  initMessageListener() {
    if (this.isApp) {
      window.addEventListener("message", (event) => this.handleMessageEvent(event) );
    }
  }

  handleMessageEvent(event) {
    if(event.data.action === 'checkout_cart') {
      window.location.href = "/warenkorb/anzeigen";
    }
  }

  gaTracking(action, artikeldetails) {
    let eventName;
    if (action === "add_product") {
      eventName = "add_to_cart";
    } else if (action === "remove_product") {
      eventName = "remove_from_cart";
    }
    const htmlCallback = `
    <dl-event name="${eventName}" step="0" currency="${artikeldetails.waehrung}" totalvalue="${artikeldetails.verkaufsbetrag}">
        <dl-product product-id="${artikeldetails.artikelnummer}" product-myinfo="${artikeldetails.artikelId}" product-price="${artikeldetails.verkaufsbetrag}" product-quantity="1" product-name="${artikeldetails.titel}" product-autor="${artikeldetails.zusatzinformation}" product-ean="${artikeldetails.ean}" product-streichpreis="${artikeldetails.streichbetrag}" product-shopid="${artikeldetails.warengruppe.id}" product-category="${artikeldetails.warengruppe.bezeichnung}/${artikeldetails.kategoriepfad}" product-lieferbar="${artikeldetails.lieferaussage}" product-variant="${artikeldetails.sortiment}"></dl-product>
    </dl-event>`;
    this.insertAdjacentHTML('afterbegin', htmlCallback);
  }

  get isApp() {
    return (this.dataset.isApp === "true");
  }
}

if (!customElements.get("livebuy-warenkorb")) {
  customElements.define("livebuy-warenkorb", LivebuyWarenkorb);
}
